<template>
  <div class="container">
    <div class="title">
      企业信息
    </div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
      label-position="left"
    >
      <FormItem label="公司名称" prop="company_name">
        <i-Input
          v-model="formValidate.company_name"
          placeholder="请填写公司名称"
        ></i-Input>
      </FormItem>
      <FormItem label="公司地址" prop="address">
        <i-Input
          v-model="formValidate.address"
          placeholder="请填写公司地址"
        ></i-Input>
      </FormItem>
      <FormItem label="联系人" prop="contact">
        <i-Input
          v-model="formValidate.contact"
          placeholder="请填写公司联系人"
        ></i-Input>
      </FormItem>
      <FormItem label="手机号码" prop="contact_tel">
        <i-Input
          v-model="formValidate.contact_tel"
          placeholder="请填写手机号码"
        ></i-Input>
      </FormItem>
      <FormItem label="邮箱账号" prop="email">
        <i-Input
          v-model="formValidate.email"
          placeholder="请填写邮箱号码"
        ></i-Input>
      </FormItem>
      <FormItem label="需要查找的药品" prop="product">
        <i-Input
          v-model="formValidate.product"
          placeholder="多个药品以逗号隔开"
        ></i-Input>
      </FormItem>
      <FormItem label="营业执照" prop="business_license_image">
        <div
          class="demo-upload-list"
          v-for="(item, index) in uploadList"
          :key="index"
        >
          <template v-if="item.status === 'finished'">
            <img :src="item.response.data.url" />
            <div class="demo-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="handleView(item)"
              ></Icon>
              <Icon
                type="ios-trash-outline"
                @click.native="handleRemove(index)"
              ></Icon>
            </div>
          </template>
          <template v-else>
            <Progress
              v-if="item.showProgress"
              :percent="item.percentage"
              hide-info
            ></Progress>
          </template>
        </div>
        <Upload
          ref="upload"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          multiple
          type="drag"
          :action="url"
          :headers="headers"
          style="display: inline-block;width:100px;"
        >
          <div style="width: 100px;height:100px;line-height: 100px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <Modal title="查看图片" v-model="visible">
          <img :src="imgName" v-if="visible" style="width: 100%" />
        </Modal>
      </FormItem>
      <div class="btn-box">
        <Button type="primary" size="large" @click="handleSubmit()"
          >提交</Button
        >
        <Button size="large" @click="handleReset()" style="margin-left: 8px"
          >重置</Button
        >
      </div>
    </Form>
  </div>
</template>

<script>
import { setUserCompany } from "@api/user";
import UpLoad from "@/mixins/UpLoad";
export default {
  name: "Company",
  mixins: [UpLoad],
  data() {
    var telCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系人姓名"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确手机号码"));
        } else {
          callback();
        }
      }
    };
    var emailCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱账号"));
      } else {
        if (
          // eslint-disable-next-line no-useless-escape
          !/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确的邮箱账号"));
        } else {
          callback();
        }
      }
    };
    return {
      formValidate: {
        company_name: "",
        address: "",
        contact: "",
        contact_tel: "",
        email: "",
        product: "",
        business_license_image: []
      },
      ruleValidate: {
        company_name: [
          { required: true, trigger: "blur", message: "请输入公司名称" }
        ],
        address: [
          { required: true, trigger: "blur", message: "请输入公司地址" }
        ],
        contact: [
          { required: true, trigger: "blur", message: "请输入公司联系人" }
        ],
        contact_tel: [{ required: true, trigger: "blur", validator: telCheck }],
        email: [{ required: true, trigger: "blur", validator: emailCheck }],
        product: [
          { required: true, trigger: "blur", message: "请输入需要查找的药品" }
        ]
      }
    };
  },
  methods: {
    handleSubmit() {
      this.uploadList.forEach(item => {
        this.formValidate.business_license_image.push(item.response.data.url);
      });
      if (this.formValidate.business_license_image.length < 1) {
        this.$Message.error("请上传营业执照图片");
        return;
      }
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          setUserCompany(this.formValidate).then(res => {
            if (res.status === 200) {
              this.$Message.success("提交成功");
              this.$router.push("/home/verifyCenter");
            }
          });
        } else {
          this.$Message.error("请信息填完完整");
        }
      });
    },
    handleReset() {
      this.$refs.formValidate.resetFields();
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  width: 600px
  margin: 0 auto
  background #fff
  padding: 10px 20px
  .title
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    font-weight: 700;
  .more-content
    width 100%
    text-align center
  .btn-box
    padding: 20px 200px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ddd;
.demo-upload-list
  display: inline-block;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  margin-right: 4px;
.demo-upload-list img
  width: 100%;
  height: 100%;
.demo-upload-list-cover
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.6);
.demo-upload-list:hover .demo-upload-list-cover
  display: block;
.demo-upload-list-cover i
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
</style>
